export enum RTPageModuleType {
  title,
  position1,
  position2,
  buttonName,
  position3,
  position4,
  logo,
  exchangeLogo,
  exchangeTitle,
}
